import { render, staticRenderFns } from "./BillDues.vue?vue&type=template&id=b4f20dbe&scoped=true&"
import script from "./BillDues.vue?vue&type=script&lang=js&"
export * from "./BillDues.vue?vue&type=script&lang=js&"
import style0 from "./BillDues.vue?vue&type=style&index=0&id=b4f20dbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f20dbe",
  null
  
)

export default component.exports